import { make } from 'vuex-pathify';
import actions from './actions';

const initialState = {
  events: [],
};

export default {
  namespaced: true,
  state:      initialState,
  getters:    {
    ...make.getters(initialState),
  },
  mutations: {
    ...make.mutations(initialState),
  },
  actions: {
    ...make.actions(initialState),
    ...actions,
  },
};
